import { Paper, PaperProps, styled } from '@mui/material';
import React, { FC } from 'react';

const PaperCard: FC<PaperProps> = (props) => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    ...theme.typography.body2,
    padding: theme.spacing(1.5, 2),
    boxShadow: 'none',
    border: `1px solid #ebebef`,
    borderRadius: theme.spacing(1.25),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
  }));

  return <Item {...props}></Item>;
};

export default PaperCard;
